import { AxiosResponse } from 'axios';
import { UserResponse } from '@models/response';
import { LoginRequest } from '@models/request';
import { api } from './base/api';
import { IAuthApi } from './base/authApi';
import { Result } from '../models/common/resultResponse';

const baseRoute: string = 'Auth';

export class AuthApi extends IAuthApi {
  loginApi(
    request: LoginRequest
  ): Promise<AxiosResponse<Result<UserResponse>>> {
    return api.post(`${baseRoute}/login`, request);
  }
  verifyIfExistsUserLoggedIn(
    username: string
  ): Promise<AxiosResponse<Result<boolean>, any>> {
    return api.get(`${baseRoute}/verifyIfExistsUserLoggedIn`, {
      params: { username }
    });
  }
  logout(): Promise<AxiosResponse<Result<void>, any>> {
    return api.post(`${baseRoute}/logout`);
  }
}

